import React from "react";
import { PatientCardSkeleton } from "./PatientCardSkeleton";
import styles from "./assessmentDetailSkeleton.module.scss";

const DetailLine = ({ className = "" }: { className?: string }) => <span className={`${styles.skeleton} ${className}`} />;

export const AssessmentDetailSkeleton = () => (
  <div className={styles.container} aria-busy="true" aria-label="Loading assessment detail" data-testid="assessment-detail-skeleton">
    <PatientCardSkeleton />

    <section className={styles.assessmentSummary} aria-hidden="true">
      <div className={styles.summaryContent}>
        <DetailLine className={styles.assessmentTitle} />
        <div className={styles.summaryMetadata}>
          <DetailLine />
          <DetailLine />
          <DetailLine />
          <DetailLine />
        </div>
      </div>
      <div className={styles.summaryStatus}>
        <DetailLine className={styles.statusBadge} />
        <DetailLine className={styles.statusAction} />
      </div>
      <div className={styles.auditDetails}>
        <DetailLine />
        <DetailLine />
        <DetailLine />
      </div>
    </section>

    <section className={styles.characteristics} aria-hidden="true">
      <div className={styles.tabRail}>
        {[0, 1, 2, 3, 4].map((item) => (
          <DetailLine key={item} className={styles.tabItem} />
        ))}
      </div>
      <div className={styles.tabContent}>
        <DetailLine className={styles.contentHeading} />
        <DetailLine className={styles.contentLineLong} />
        <DetailLine className={styles.contentLineMedium} />
        <DetailLine className={styles.contentCard} />
        <DetailLine className={styles.contentCard} />
      </div>
    </section>
  </div>
);
